export default __webpack_public_path__ + "static/Sound_Making of Menmosyne-9832b9fdc29f6ff01f7f02d513dbe224.mp3";